<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="650"
      persistent
      scrollable
    >
      <v-card v-if="domain">
        <v-toolbar
          class="pl-1"
          extension-height="40"
          flat
          height="80"
          max-height="120"
        >
          <v-avatar
            :color="$t('Settings.Domain.DatabaseBackup.Toolbar.Color')"
          >
            <v-icon dark>
              {{ $t('Settings.Domain.DatabaseBackup.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Settings.Domain.DatabaseBackup.Toolbar.Title') }}
            </div>

            <div class="text-caption">
              {{ $t('Settings.Domain.DatabaseBackup.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-3">
          <v-form
            ref="dialogForm"
            v-model="dialogFormValid"
            @submit.prevent
          >
            <v-container
              class="pa-0"
              fluid
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="model.Name"
                    :label="$t('Settings.Domain.DatabaseBackup.Field.Domain.Label')"
                    :prepend-icon="$t('Settings.Domain.DatabaseBackup.Field.Domain.Icon')"
                    hide-details
                    required
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    :label="$t('Settings.Domain.DatabaseBackup.Field.Database.Label')"
                    :prepend-icon="$t('Settings.Domain.DatabaseBackup.Field.Database.Icon')"
                    :value="model.Database"
                    hide-details
                    readonly
                    required
                  />
                </v-col>

                <v-col>
                  <v-icon left>
                    {{ $t('Settings.Domain.DatabaseBackup.Field.Active.Icon') }}
                  </v-icon>
                  <div class="d-inline-block">
                    <h5 class="text-body-2 font-weight-bold">
                      {{ $t('Settings.Domain.DatabaseBackup.Field.Active.Title') }}
                    </h5>
                    <div class="text-caption">
                      {{ $t('Settings.Domain.DatabaseBackup.Field.Active.Subtitle') }}
                    </div>
                  </div>
                </v-col>
                <v-col class="shrink">
                  <v-switch
                    v-model="model.Active"
                    :label="model.Active ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                    class="ma-0 d-inline-flex ml-2"
                    color="cyan"
                    hide-details
                    inset
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
          <v-btn
            :disabled="dialogSaving"
            :loading="dialogSaving"
            class="green white--text elevation-0"
            @click="onSaveButtonClick"
          >
            {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppData from '../../../mixins/appdata'
import Auth from '../../../mixins/auth'
import {clone} from '@/lib/helper/helper.js'

export default {
  name      : 'DomainDatabaseBackup',
  components: {},
  mixins    : [AppData, Auth],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    domain: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      dialogSaving   : false,
      dialogFormValid: false,
      model          : {
        Id      : null,
        Active  : false,
        Name    : '',
        Database: ''
      }
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.dialogSaving = false

        this.$nextTick(() => {
          this.model = {
            Id      : this.domain?.Id,
            Active  : this.domain?.BackupDbActive ?? false,
            Name    : this.domain?.BackupDbName ?? this.domain?.Domain ?? '',
            Database: this.domain?.DatabaseName ?? ''
          }
        })
      }
    }
  },
  created() {
  },
  mounted() {
    this.$bus.$on(window.SocketCommand.Settings.Domains.BackupDB, this.onResult)
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off(window.SocketCommand.Settings.Domains.BackupDB, this.onResult)
  },
  methods: {
    onSaveButtonClick() {
      this.$refs.dialogForm.validate()
      if (!this.dialogFormValid) return
      this.dialogSaving = true

      if (this.$refs.dialogForm) this.$refs.dialogForm.resetValidation()

      const payload = clone(this.model)
      window.callAS(window.SocketCommand.Settings.Domains.BackupDB, payload)
    },

    onResult(response) {
      if (response.status !== 'fail') {
        this.$bus.$emit('app-show-notification', {
          body: response?.type || '',
          type: 'success',
          icon: 'info'
        })
        this.onCancelButtonClick()
        this.$emit('save:success')
      } else {
        this.$bus.$emit('app-show-notification', {
          body: response?.type || response?.result || '',
          type: 'error',
          icon: 'warning'
        })
      }
      this.dialogSaving = false
    },

    onCancelButtonClick() {
      this.dialogSaving = false
      this.model = {
        Id      : null,
        Active  : false,
        Name    : '',
        Database: ''
      }

      this.isVisible = false
      if (this.$refs.dialogForm) this.$refs.dialogForm.resetValidation()
    }
  }
}
</script>
